import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import {
  assignmentActivityLabel,
  getDraftOrPeerReviewLabel,
  getTool,
} from '@macmillan-learning/gradebook-shared';

import s from './ToolLabel.module.css';
import { getConfigObject } from '../../utils/config';

const ACTIVITY_LABEL_ALIASES = {
  'Writing Assignment': 'Writing',
};

function ToolLabel(props) {
  const { inProgressLabel, isIndividualStudentGradebook } = props;
  const name = props.activity.type || props.activity.tool;
  let labelName = assignmentActivityLabel(props.activity);
  let newLineLabel;
  if (typeof labelName === 'object') {
    newLineLabel = labelName.extraCreditLabel;
    labelName = labelName.label;
  }
  const currentTool = getTool(name);
  const hasParentId = props.activity && props.activity.parent_id; // this means the current assignment is a draft
  const labelClass = currentTool ? s[name] : s.default;
  const aliasLabel = _get(ACTIVITY_LABEL_ALIASES, labelName, labelName);

  if (hasParentId) {
    const { name: activityName, subtype, tool } = props.activity;
    const draftLabel = getDraftOrPeerReviewLabel(activityName, tool, subtype);

    labelName = `${aliasLabel} - ${draftLabel}`;
  }

  if (props.activity && props.activity.isFinalAssignment) {
    const { FF_DRAFT_NUMBER_LABELING = false } = getConfigObject();
    const finalLabel =
      FF_DRAFT_NUMBER_LABELING && props.activity.finalDraftNumber
        ? `Draft ${props.activity.finalDraftNumber}`
        : 'Final Paper';
    labelName = `${aliasLabel} - ${finalLabel}`;
  }

  if (isIndividualStudentGradebook) {
    const divider = newLineLabel && '|';

    return (
      <div className={s.inlineLabel}>
        {labelName} {divider} {newLineLabel} {inProgressLabel}
      </div>
    );
  }

  return (
    <div
      className={`${s.root} ${props.classNames}`}
      style={{ flexDirection: 'column' }}
      data-test-id={props.testId}
    >
      <div
        data-test-id="assignment_type"
        className={`${props.containerClass} ${s.label} ${labelClass} ${s.leftAlign}`}
      >
        {labelName}
      </div>
      {(inProgressLabel || newLineLabel) && (
        <div
          className={`${props.containerClass} ${s.label} ${labelClass}`}
          style={{ display: 'flex', gap: '3px' }}
        >
          {newLineLabel}
          {inProgressLabel}
        </div>
      )}
    </div>
  );
}

ToolLabel.propTypes = {
  activity: PropTypes.object,
  containerClass: PropTypes.string,
  classNames: PropTypes.string,
  testId: PropTypes.string,
};

export default ToolLabel;
